import React from 'react';
import {
  useColorMode,
  useColorModeValue,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ColorModeSwitcher = props => {
  const { t } = useTranslation();
  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue(
    t('colorMode.dark', 'ciemny'),
    t('colorMode.light', 'jasny'),
  );
  const SwitchIcon = useColorModeValue(FaMoon, FaSun);
  const switchColorModeLabel = t('switchColorMode', 'Zmień na tryb {{text}}', {
    text,
  });

  return (
    <Tooltip label={switchColorModeLabel} placement='top'>
      <IconButton
        size='md'
        fontSize='lg'
        aria-label={switchColorModeLabel}
        variant='ghost'
        color='current'
        marginLeft='2'
        onClick={toggleColorMode}
        icon={<SwitchIcon />}
        {...props}
      />
    </Tooltip>
  );
};

export default ColorModeSwitcher;
